import { UiTheme } from '../../theme'

export default (theme: UiTheme) => {
  const commonChildStyles = {
    position: 'absolute',
    display: 'block',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    opacity: 0,
    transition: theme.settings.transitions.regular,
  }

  return {
    wrapper: {
      base: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: '50%',
        overflow: 'hidden',
        textAlign: 'center',
        backgroundColor: '#b6c6d6',
        color: 'black',
        fontWeight: 700,
        fontSize: '11px',
        margin: 0,
      },

      clickable: {
        cursor: 'pointer',

        ':after': {
          ...commonChildStyles,
          content: ' ',
          zIndex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
          pointerEvents: 'none',
        },

        ':hover:after': {
          opacity: 1,
        },

        ':active:after': {
          opacity: 0.5,
        },

        '.intent-mouse &:focus': {
          outline: 'none',
        },
      },

      sizes: {
        small: {
          width: '20px',
          height: '20px',
          lineHeight: '20px',
        },

        medium: {
          width: '30px',
          height: '30px',
          lineHeight: '30px',
        },

        large: {
          width: '60px',
          height: '60px',
          lineHeight: '60px',
          fontSize: '16px',
        },
      },
    },

    img: {
      base: {
        ...commonChildStyles,
        objectFit: 'cover',
      },

      visible: {
        opacity: 1,
      },
    },
  }
}
